import React from 'react'
import { FormattedMessage } from 'react-intl'

export default ({getKey}) => [
  <h5 key={getKey()} className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
    <FormattedMessage id="booking.amountForm.category" defaultMessage="Welcome" />
  </h5>,
  <h1 key={getKey()} className="border-b pb-8 text-4xl">
    <FormattedMessage id="booking.amountForm.header" defaultMessage="Let's get you on the hill!" />
  </h1>
]